import { useContext } from "react";
import {
  OnboardingFlowsContext,
  OnboardingFlowsContextValue,
} from "./OnboardingFlowsContext";

const noopContext: OnboardingFlowsContextValue = {
  activeFlow: null,
  activeStep: 0,
  runFlow: () => {},
  nextStep: () => {},
  dismissFlow: () => {},
  isStepActive: () => false,
  getStep: () => undefined,
  getTotalSteps: () => 0,
};

export const useOnboardingFlows = (): OnboardingFlowsContextValue => {
  const context = useContext(OnboardingFlowsContext);
  return context ?? noopContext;
};
